import { render, staticRenderFns } from "./AppendixCredit.vue?vue&type=template&id=5df4947f&scoped=true"
import script from "./AppendixCredit.vue?vue&type=script&lang=js"
export * from "./AppendixCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df4947f",
  null
  
)

export default component.exports